import { render, staticRenderFns } from "./ordersTb.vue?vue&type=template&id=3ddf0276&scoped=true"
import script from "./ordersTb.vue?vue&type=script&lang=js"
export * from "./ordersTb.vue?vue&type=script&lang=js"
import style0 from "./ordersTb.vue?vue&type=style&index=0&id=3ddf0276&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf0276",
  null
  
)

export default component.exports